webpackJsonp([33,35],{

/***/ 3:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (config) {
	  this.distanceX = 0;
	  this.distanceY = 0;
	  this.startPos = [0, 0];
	  this.currentPos = [0, 0];
	  this.startTime = 0;
	  this.endTime = 0;
	  this.speedX = 0;
	  this.speedY = 0;
	
	  this.state = 'FREE';
	  this.alias = config.alias || '';
	  this.dom = config.dom;
	  this.eventType = config.type || 'swipe';
	  this.callback = config.doing || function () {};
	  this.donecallback = config.done || function () {};
	
	  this.mode = config.mode || 'strict';
	
	  var t = this;
	
	  this.handleTouchStart = function (e) {
	    t.startTime = new Date().getTime();
	    t.state = 'START';
	    var touch = e.targetTouches[0];
	    t.startPos = [touch.pageX, touch.pageY];
	
	    t.callback('touchstart', {
	      distance: { x: t.distanceX, y: t.distanceY },
	      position: t.startPos,
	      state: t.state,
	      alias: t.alias
	    });
	  };
	
	  this.handleTouchMove = function (e) {
	    t.state = 'MOVING';
	    var touch = e.targetTouches[0];
	    t.currentPos = [touch.pageX, touch.pageY];
	    t.distanceX = t.currentPos[0] - t.startPos[0];
	    t.distanceY = t.currentPos[1] - t.startPos[1];
	    t.callback('touchmove', {
	      distance: { x: t.distanceX, y: t.distanceY },
	      position: t.currentPos,
	      state: t.state,
	      alias: t.alias
	    });
	  };
	
	  this.handleTouchEnd = function () {
	    t.state = 'END';
	    t.endTime = new Date().getTime();
	    var time = Math.floor((t.endTime - t.startTime) / 1000);
	
	    if (t.currentPos[0] === 0 || t.currentPos[1] === 0) {
	      t.currentPos = t.startPos;
	    }
	
	    t.distanceX = t.currentPos[0] - t.startPos[0];
	    t.distanceY = t.currentPos[1] - t.startPos[1];
	
	    if (time === 0) time = 1;
	    t.speedX = Math.abs(t.distanceX / time);
	    t.speedY = Math.abs(t.distanceY / time);
	
	    if (!t.actions[t.eventType]()) {
	      t.callback('touchend', {
	        distance: { x: t.distanceX, y: t.distanceY },
	        speed: { x: t.speedX, y: t.speedY },
	        position: t.currentPos,
	        state: t.state,
	        alias: t.alias
	      });
	    } else {
	      if (t.mode === 'unstrict') {
	        t.callback('touchend', {
	          distance: { x: t.distanceX, y: t.distanceY },
	          speed: { x: t.speedX, y: t.speedY },
	          position: t.currentPos,
	          state: t.state,
	          alias: t.alias
	        });
	      }
	
	      t.donecallback({
	        distance: { x: t.distanceX, y: t.distanceY },
	        speed: { x: t.speedX, y: t.speedY },
	        position: t.currentPos,
	        state: t.state,
	        alias: t.alias
	      });
	    }
	
	    t.state = 'FREE';
	    t.distanceX = 0;
	    t.distanceY = 0;
	    t.startTime = 0;
	    t.endTime = 0;
	    t.speedX = 0;
	    t.speedY = 0;
	    t.startPos = [0, 0];
	    t.currentPos = [0, 0];
	  };
	
	  this.actions = {
	    swipe: function swipe() {
	      return true;
	    },
	    swipeDown: function swipeDown() {
	      if (t.distanceY > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeUp: function swipeUp() {
	      if (t.distanceY < -60) {
	        return true;
	      }
	      return false;
	    },
	    swipeLeft: function swipeLeft() {
	      if (t.distanceX < -60) {
	        return true;
	      }
	      return false;
	    },
	    swipeRight: function swipeRight() {
	      if (t.distanceX > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeX: function swipeX() {
	      if (Math.abs(t.distanceX) > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeY: function swipeY() {
	      if (Math.abs(t.distanceY) > 60) {
	        return true;
	      }
	      return false;
	    }
	  };
	
	  this.init = function () {
	    this.dom.addEventListener('touchstart', this.handleTouchStart);
	    this.dom.addEventListener('touchmove', this.handleTouchMove);
	    this.dom.addEventListener('touchend', this.handleTouchEnd);
	  };
	
	  this.destory = function () {
	    this.dom.removeEventListener('touchstart', this.handleTouchStart);
	    this.dom.removeEventListener('touchmove', this.handleTouchMove);
	    this.dom.removeEventListener('touchend', this.handleTouchEnd);
	  };
	
	  this.init();
	};

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(184)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(167),
	  /* template */
	  __webpack_require__(283),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _touchit = __webpack_require__(3);
	
	var _touchit2 = _interopRequireDefault(_touchit);
	
	var _toast = __webpack_require__(32);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'touchdemo',
	  components: {
	    Toast: _toast2.default
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.touchType.forEach(function (type, key) {
	      _this.touchit[key] = new _touchit2.default({
	        alias: type,
	        dom: _this.$refs[type],
	        type: type,
	        done: _this.done,
	        doing: _this.doing
	      });
	    });
	  },
	
	  methods: {
	    done: function done(e) {
	      this.content = 'You ' + e.alias;
	      this.$refs.success.open();
	    },
	    doing: function doing(et, e) {
	      this.position = e.position;
	      this.distance = e.distance;
	    }
	  },
	  data: function data() {
	    return {
	      content: '',
	      position: [0, 0],
	      speed: { x: 0, y: 0 },
	      distance: { x: 0, y: 0 },
	      touchit: [null, null, null, null, null, null, null],
	      touchType: ['swipe', 'swipeDown', 'swipeUp', 'swipeLeft', 'swipeRight', 'swipeX', 'swipeY']
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.touchit.forEach(function (item) {
	      item.destory();
	    });
	  }
	};

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(26)();
	// imports
	
	
	// module
	exports.push([module.id, ".toucharea{margin:4px;background:#fff;padding:40px 0}.infobox{padding:20px;text-align:left;background:#fff;margin-bottom:10px}", "", {"version":3,"sources":["/./src/other/touch/demo.vue"],"names":[],"mappings":"AACA,WACE,WAAY,AACZ,gBAAiB,AACjB,cAAgB,CACjB,AACD,SACE,aAAc,AACd,gBAAiB,AACjB,gBAAiB,AACjB,kBAAoB,CACrB","file":"demo.vue","sourcesContent":["\n.toucharea{\n  margin: 4px;\n  background: #fff;\n  padding: 40px 0;\n}\n.infobox{\n  padding: 20px;\n  text-align: left;\n  background: #fff;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(175);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(39)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-f679ecde!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./demo.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-f679ecde!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./demo.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 283:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "layout-main-absolute"
	  }, [_c('div', {
	    staticClass: "flex-box"
	  }, [_c('div', {
	    ref: "swipe",
	    staticClass: "flex-item-1 toucharea "
	  }, [_vm._v("\n      Swipe\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "flex-box"
	  }, [_c('div', {
	    ref: "swipeUp",
	    staticClass: "flex-item-1 toucharea"
	  }, [_vm._v("\n      Swipe Up\n    ")]), _vm._v(" "), _c('div', {
	    ref: "swipeDown",
	    staticClass: "flex-item-1 toucharea"
	  }, [_vm._v("\n      Swipe Down\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "flex-box"
	  }, [_c('div', {
	    ref: "swipeLeft",
	    staticClass: "flex-item-1 toucharea "
	  }, [_vm._v("\n      Swipe Left\n    ")]), _vm._v(" "), _c('div', {
	    ref: "swipeRight",
	    staticClass: "flex-item-1 toucharea"
	  }, [_vm._v("\n      Swipe Right\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "flex-box"
	  }, [_c('div', {
	    ref: "swipeX",
	    staticClass: "flex-item-1 toucharea "
	  }, [_vm._v("\n      Swipe X\n    ")]), _vm._v(" "), _c('div', {
	    ref: "swipeY",
	    staticClass: "flex-item-1 toucharea"
	  }, [_vm._v("\n      Swipe Y\n    ")])]), _vm._v(" "), _c('toast', {
	    ref: "success",
	    attrs: {
	      "type": "success",
	      "content": _vm.content
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/33.46cc46bcc038802ba3ca.js